module.exports = __webpack_public_path__ + "static/media/contact-190519.ffe90940.jpg";